import { useState } from 'react';
import { Table, Button, Modal } from "react-bootstrap";
import { DateHelpers } from '../../Helpers/Date/DateHelpers';
import { AppHelpers } from '../../Helpers/App/AppHelpers';
import { toastSuccessMessage } from 'wup-module1-base/src/helpers';
import { Services_Types_Enum } from '../../Constants/Enums';

const MeetingList = (props) => {
    const meetings = Object.values(props.meetings);
    const [checkedItems, setCheckedItems] = useState({});
    const [showModal, setShowModal] = useState(false);

    const handleCheckboxChange = (id) => {
        setCheckedItems((prev) => {
            const newCheckedItems = { ...prev };
            if (newCheckedItems[id]) {
                delete newCheckedItems[id];
            } else {
                newCheckedItems[id] = true;
            }
            return newCheckedItems;
        });
    };

    const onMeetingCanceled = () => {
        const checkedIds = Object.keys(checkedItems).map(Number);
        const updatedMeetings = meetings.filter(meeting => !checkedIds.includes(meeting.id));
   
        props.setMeetings(updatedMeetings);
        setCheckedItems({});
        setShowModal(false);
        toastSuccessMessage(`Pomyślnie odwołano udział w spotkaniu`);
    };

    const handleCancel = () => {
        const data = {
            ids: Object.keys(checkedItems).map(Number),
        };
        
        props.cancelMeetings(data, onMeetingCanceled);
    }

    const handleSelectAll = () => {
    const allChecked = meetings.every((meeting) => checkedItems[meeting.id]);
    if (allChecked) {
        setCheckedItems({});
    } else {
        setCheckedItems(Object.fromEntries(meetings.map(({ id }) => [id, true])));
    }
    };

    const handleAction = () => {
    setShowModal(true);
    };
    
    const allChecked = meetings.length > 0 && meetings.every((meeting) => checkedItems[meeting.id]);

    if (meetings.length === 0) {
        return;
    }

    return (
    <div>
        <Button onClick={handleAction} disabled={Object.keys(checkedItems).length === 0} className="my-1 btn-download-file">Odwołaj udział</Button>
        <Table striped bordered>
            <thead>
            <tr>
                <th aria-label="Zaznacz/Odznacz">
                <input
                    type="checkbox"
                    checked={allChecked}
                    onChange={handleSelectAll}
                    title='Zaznacz/Odznacz wszystkie'
                />
                </th>
                <th>Rodzaj usługi</th>
                <th>Typ usługi</th>
                <th>Rodzaj spotkania</th>
                <th>Lokalizacja</th>
                <th>Doradca</th>
                <th>Termin spotkania</th>
            </tr>
            </thead>
            <tbody>
            {Array.isArray(meetings) && meetings.length > 0 && meetings.map((meeting) => (
                <tr key={meeting.id}>
                <td>
                    <input
                    type="checkbox"
                    checked={checkedItems[meeting.id] || false}
                    onChange={() => handleCheckboxChange(meeting.id)}
                    title='Zaznacz/Odznacz'
                    />
                </td>
                <td>{AppHelpers.getServiceNameByIdFromEnum(meeting.service_type)}</td>
                <td>{meeting.exclusive_service_type_name && !(Services_Types_Enum.Consultation.id == meeting.service_type) ? meeting.exclusive_service_type_name : ""}</td>
                <td>{AppHelpers.getMeetingNameByIdFromEnum(meeting.meeting_type)}</td>
                <td>{meeting.localization}</td>
                <td>{meeting.presenter.name} {meeting.presenter.surname}</td>
                <td>od {DateHelpers.formatFullDateHours(meeting.date_from)} do {DateHelpers.formatFullDateHours(meeting.date_to)}</td>
                </tr>
            ))}
            </tbody>
        </Table>
        <Modal className='session session-modal' show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header>
            <Modal.Title>Czy na pewno chcesz odwołać wybrane spotkania?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {Object.keys(checkedItems).length > 0 ? (
                    <ul className='mt-2'>
                        {Object.entries(checkedItems).map(([key, value]) => {
                            if (!value) return null;
                            const meeting = meetings.find((item) => item.id == key);
                            if (!meeting) return null;
                            
                            return (
                                <li key={key}>
                                    {AppHelpers.getServiceNameByIdFromEnum(meeting.service_type)} - {DateHelpers.formatFullDateHours(meeting.date_from)} do {DateHelpers.formatFullDateHours(meeting.date_to)}
                                </li>
                            );
                        })}
                    </ul>
                ) : (
                    <p>Nie wybrano żadnych elementów.</p>
                    )
                }
            </Modal.Body>
            <Modal.Footer>
            <Button variant="primary" className='contact-modal-btn-add' onClick={() => handleCancel()}>
                Odwołaj
            </Button>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
                Zamknij
            </Button>
            </Modal.Footer>
        </Modal>
    </div>
    );
}
export default MeetingList;
